import React, { createElement, useEffect, useState } from "react";
import { connect } from "react-redux";
import { Button, Modal, Timeline, Progress, Rate, notification, Typography, Image, Card, Skeleton, Form, Input, Comment, Tooltip, Avatar, Popover } from "antd";
import { DislikeOutlined, LikeOutlined, DislikeFilled, LikeFilled } from "@ant-design/icons";
import LandingPageAppBar from "../components/LandingPageAppBar";
import { makeStyles } from "@material-ui/core/styles";
import { Link } from "react-router-dom";
import { viewAllCoursesAction } from "../redux/actions/courseActions";
import Loader from "../components/common/Loader";
import Helmet from "react-helmet";
import homePicture from "../assets/images/undraw_laravel_and_vue_59tp.svg";
import Footer from "../components/common/Footer";
import MobileFooter from "../components/common/MobileFooter";
import "./index.css";

import AllCourses from "../components/common/AllCourses";

const Home = () => {


  return (
    <div className="container">
      <LandingPageAppBar />
      <AllCourses/>
    </div>
  );
};


export default Home;
